// Formatters format the value from the Redux store to be displayed in the field
// input.

import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { iso8061ToYYYY } from '../date';

/**
 * Formats dates used for education form fields.
 *
 * @param {String} value Date, entered as YYYY-MM-DD, formatted as YYYY.
 */
export const formatEducationDate = iso8061ToYYYY;

/**
 * Returns a formatter for the End Date field in education forms.
 *
 * @param {Boolean} currentValue Value of the "Current" field.
 */
export const formatEducationEndDate = (currentValue) => (value) => (
  currentValue ? 'Current' : formatEducationDate(value)
);

/**
 * Formats dates used for experience form fields.
 *
 * @param {String} value Date, entered as MMYYYY, formatted as MM/YYYY
 */
export const formatExperienceDate = (value) => {
  if (!value) { return ''; }

  // format YYYY-MM-DD from server
  if (value.length === 10) {
    return format(parseISO(value), 'MM/yyyy');
  }

  // format user input
  const onlyNums = value.replace(/[^\d]/g, '');

  // prevent slash from being added immediately after first digit
  if (onlyNums.length < 2) { return onlyNums; }

  // MM/YYYY
  return `${onlyNums.slice(0, 2)}/${onlyNums.slice(2, 6)}`;
};

/**
 * Returns a formatter for the End Date field in experience forms.
 *
 * @param {Boolean} currentValue Value of the "Current" field.
 */
export const formatExperienceEndDate = (currentValue) => (value) => (
  currentValue ? 'Current' : formatExperienceDate(value)
);

/**
 * Formats dates used for license/certification form fields.
 *
 * @param {String} value Date, entered as YYYY-MM-DD, formatted as YYYY.
 */
export const formatLicenseCertDate = iso8061ToYYYY;

/**
 * Formats veteran value to a string to be used in a select dropdown or react input.
 * @param {*} value
 */
export const formatVeteran = (value) => (value != null ? value.toString() : '');
